// Service-worker registration for the Go2Fix PWA.
//
// We use vite-plugin-pwa's virtual:pwa-register module. Auto-update mode lets
// users always get the latest UI within one reload after a fresh deploy. We
// surface "update available" and "offline ready" via window CustomEvents so
// that any UI component (a toast, a banner) can listen without coupling.

import { registerSW } from 'virtual:pwa-register'

// Hourly update poll while the tab is open. New SW will be detected and the
// 'pwa:update-available' event fires; the user clicks "reload" to apply.
const POLL_MS = 60 * 60 * 1000

export const updateSW = registerSW({
  immediate: true,
  onRegistered(reg) {
    if (!reg) return
    // Periodic checks for new versions.
    window.setInterval(() => {
      reg.update().catch(() => {
        /* network error is fine — we'll try again next interval */
      })
    }, POLL_MS)
  },
  onRegisterError(err) {
    // Don't block the app on a SW registration failure.
    // Sentry already captures this if FE Sentry is initialised.
    // eslint-disable-next-line no-console
    console.error('[PWA] SW registration failed:', err)
  },
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('pwa:update-available'))
  },
  onOfflineReady() {
    window.dispatchEvent(new CustomEvent('pwa:offline-ready'))
  },
})
